<template>
	<button :class="['action-button', { 'action-button--remove-margin': removeMargin }]" @click="gotToAction_ClickHandler" :style="style">{{ title }}</button>
</template>

<script>
export default {
	name: 'action-button',
	props: {
		title: {
			type: String,
			default: null
		},
		removeMargin: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: 'var(--main-color)'
		}
	},
	computed: {
		style() {
			const default_styles = {
				backgroundColor: this.color,
			}
			return Object.assign(default_styles, this.customStyles)
		}
	},
	methods: {
		gotToAction_ClickHandler() {
			this.$emit('click')
		}
	}
}
</script>

<style scoped>
.action-button {
	outline: none;
	border: 0;
	background-color: var(--main-color);
	color: #fff;
	text-transform: uppercase;
	font-size: 12px;
	height: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 20px;
	border-radius: 3px;
	box-shadow: rgba(0,0,0,0.1) 1px 1px 5px;
	margin: 0 10px;
	cursor: pointer;
	transform: scale(1, 1);
	transition: transform 0.3s;
}
.action-button.action-button--remove-margin {
	margin: 0;
}
.action-button:hover,
.action-button:active {
	background-color: var(--main-color-dark);
}
.action-button:active {
	transform: scale(0.9, 0.9);
}
</style>


// WEBPACK FOOTER //
// src/modules/ui/ActionButton.vue